import React from 'react';
import { getAssetUrl } from '../../utils/assetUrl';

const iconImageMap: Record<string, string> = {
  calculator: getAssetUrl('images/calculator-icon.svg'),
  phone: getAssetUrl('images/phone-icon.svg'),
};

interface ButtonItem {
  text: string;
  _metadata?: { uid: string };
  url: string;
  variant: string;
  inverted: boolean;
  icon: string;
  icon_position: string;
  external: boolean;
}

interface CmsRichTextLightBlueData {
  name?: string;
  component?: string;
  body?: string;
  media?: string | null;
  media_position?: string;
  buttons?: ButtonItem[];
  _metadata?: { uid: string };
}

interface CmsRichTextLightBlueProps {
  data: CmsRichTextLightBlueData;
}

export const CmsRichTextLightBlue: React.FC<CmsRichTextLightBlueProps> = ({ data }) => {
  const buttons = data.buttons ?? [];
  const iconButtons = buttons.filter((b) => b.icon);
  const actionButtons = buttons.filter((b) => !b.icon);

  return (
    <div
      className="flex items-center justify-between w-full"
      style={{
        padding: '40px 80px 56px 80px',
        backgroundColor: '#FFFFFF',
      }}
    >
      {/* Left: icon links */}
      <div className="flex items-center gap-150">
        {iconButtons.map((button) => (
          <a
            key={button._metadata?.uid ?? button.text}
            href={button.url || undefined}
            className="flex items-center gap-50 cursor-pointer no-underline"
          >
            <div
              className="inline-flex items-center justify-center shrink-0"
              style={{
                width: '48px',
                height: '48px',
                borderRadius: '100px',
                backgroundColor: '#0987D0',
              }}
            >
              <img src={iconImageMap[button.icon]} alt={button.text} width={24} height={24} />
            </div>
            <span
              className="font-semibold capitalize"
              style={{
                color: '#0054A4',
                fontSize: '18px',
                lineHeight: 'normal',
                fontFeatureSettings: "'liga' off, 'clig' off",
              }}
            >
              {button.text}
            </span>
          </a>
        ))}
      </div>

      {/* Right: action buttons */}
      <div className="flex justify-end items-center gap-100">
        {actionButtons.map((button, index) => {
          const isPrimary = index === actionButtons.length - 1;

          const baseClasses =
            'flex items-center justify-center gap-40 rounded-200 min-h-[52px] font-semibold capitalize cursor-pointer no-underline';
          const padding = { padding: '16px 20px' };
          const typography = {
            fontSize: '18px',
            lineHeight: 'normal',
            fontFeatureSettings: "'liga' off, 'clig' off",
          };

          if (isPrimary) {
            return (
              <a
                key={button._metadata?.uid ?? button.text}
                href={button.url || undefined}
                className={`${baseClasses} text-white`}
                style={{
                  ...padding,
                  ...typography,
                  backgroundColor: '#0054A4',
                }}
              >
                {button.text}
              </a>
            );
          }

          return (
            <a
              key={button._metadata?.uid ?? button.text}
              href={button.url || undefined}
              className={`${baseClasses} border-2 bg-transparent`}
              style={{
                ...padding,
                ...typography,
                color: '#0054A4',
                borderColor: '#0054A4',
              }}
            >
              {button.text}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default CmsRichTextLightBlue;
